import { useState, useEffect } from "react";
import { IonButton } from "@ionic/react";
import { useHistory } from "react-router";
import { ASSESSMENT_STATUSES } from "../../../src/movenet/params";

interface Props {
  setAreYouThere: Function;
}
const AreYouThereModal: React.FC<Props> = ({ setAreYouThere }) => {
  const [isOptionSelected, setIsOptionSelected] = useState(false);

  useEffect(() => {
    // Set a timeout after the first render
    const timeoutId = setTimeout(() => {
      // Perform actions if the state hasn't changed after 30 seconds
      console.log("State has not changed after 30 seconds");
      setAreYouThere(false);
      if (!isOptionSelected) {
        history.push("/home");
        ASSESSMENT_STATUSES.are_you_there = true;
      }
    }, 30000);
    // Clear the timeout if the state changes before the timeout is reached
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  let history = useHistory();

  const exit_task = () => {
    const counter = sessionStorage.getItem("retry-counter")
    if(counter) sessionStorage.setItem("retry-counter", (Number(counter) + 1).toString())
    setAreYouThere(false);
    history.push("/patient-page");
    // history.replace("/phone-height-requirement");
  };

  const im_here = () => {
    setIsOptionSelected(true);
    setAreYouThere(false);
    // history.push("/patient-page");
  };

  return (
    <>
      <div className="are-you-there-modal">
        {/* <div className="d-flex justify-content-end">
          <svg
            onClick={() => {
              setAreYouThere(false);
            }}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20.9999 20.909L2.90845 2.90918M21 2.90918L2.90845 20.9091"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div> */}
        <div className="align-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="128"
            height="113"
            viewBox="0 0 128 113"
            fill="none"
          >
            <path
              d="M95.7813 113C104.21 113 112.294 109.652 118.254 103.691C124.214 97.7313 127.563 89.6477 127.563 81.2188C127.563 72.7898 124.214 64.7062 118.254 58.746C112.294 52.7859 104.21 49.4375 95.7813 49.4375C87.3523 49.4375 79.2687 52.7859 73.3085 58.746C67.3484 64.7062 64 72.7898 64 81.2188C64 89.6477 67.3484 97.7313 73.3085 103.691C79.2687 109.652 87.3523 113 95.7813 113ZM99.3125 67.0938V77.6875H106.375C108.317 77.6875 109.906 79.2766 109.906 81.2188C109.906 83.1609 108.317 84.75 106.375 84.75H95.7813C93.8391 84.75 92.25 83.1609 92.25 81.2188V67.0938C92.25 65.1516 93.8391 63.5625 95.7813 63.5625C97.7234 63.5625 99.3125 65.1516 99.3125 67.0938Z"
              fill="#802392"
            />
            <path
              opacity="0.4"
              d="M0.4375 7.0625C0.4375 3.15605 3.59355 0 7.5 0H14.5625H71.0625H78.125C82.0314 0 85.1875 3.15605 85.1875 7.0625C85.1875 10.9689 82.0314 14.125 78.125 14.125V16.5527C78.125 25.9105 74.3951 34.8932 67.774 41.5143L52.8104 56.5L60.7557 64.4453C58.3279 69.5215 56.9596 75.2156 56.9596 81.2188C56.9596 94.3506 63.4924 105.96 73.4682 113H71.0625H14.5625H7.5C3.59355 113 0.4375 109.844 0.4375 105.938C0.4375 102.031 3.59355 98.875 7.5 98.875V96.4473C7.5 87.0895 11.2299 78.1068 17.851 71.4857L32.8147 56.5L17.851 41.5143C11.2299 34.8932 7.5 25.9105 7.5 16.5527V14.125C3.59355 14.125 0.4375 10.9689 0.4375 7.0625ZM21.625 14.125V16.5527C21.625 20.7461 22.8609 24.807 25.1563 28.25H60.4688C62.742 24.807 64 20.7461 64 16.5527V14.125H21.625Z"
              fill="#002E3C"
            />
          </svg>
          <h1 className="assesment-modal-label mb-0">Are you there?</h1>
          <p className="assesment-modal-desc">
            Assessment will time out due to inactivity Tap ‘I’m Here’ to return
            to the assessment
          </p>
          <p className="assesment-modal-desc sent-text">
            {" "}
            You will automatically exit this assessment after 30 seconds.
          </p>
        </div>
        <div className="two-col-btn">
          <IonButton
            placeholder={undefined}
            className="blue-outline-btn"
            onClick={() => {
              exit_task();
            }}
          >
            {" "}
            Exit Test
          </IonButton>
          <IonButton
            placeholder={undefined}
            className="blue-btn"
            onClick={() => {
              im_here();
            }}
          >
            {" "}
            Continue
          </IonButton>
        </div>
      </div>
    </>
  );
};
export default AreYouThereModal;
